import './brand.css';

interface BrandBackdropProps {
  variant?: 'hero' | 'results' | 'board';
}

export function BrandBackdrop({ variant = 'hero' }: BrandBackdropProps) {
  return (
    <div className={['brand-backdrop', `brand-backdrop--${variant}`].join(' ')} aria-hidden="true">
      <span className="brand-backdrop__orb brand-backdrop__orb--yellow" />
      <span className="brand-backdrop__orb brand-backdrop__orb--ink" />
      <span className="brand-backdrop__grid" />
    </div>
  );
}